import { CurrencyPipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, EventEmitter, HostBinding, HostListener, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import moment from 'moment';
import { Subscription } from 'rxjs';
import { ApiService } from 'src/app/services/api.service';
import { FilterService } from 'src/app/services/filter.service';
import { PivotGridComponent } from '../../shared/charts/pivot-Grid/pivot-grid.component';
import { NewFilterService } from 'src/app/services/new-filter.service';
import { NavigationService } from 'src/app/services/navigation.service';
import { DataService } from 'src/app/services/data.service';
import { UserActivityService } from '../../../services/useractivity.service';

@Component({
  selector: 'app-ir-heat-map-card',
  templateUrl: './ir-heat-map-card.component.html',
  styleUrls: ['./ir-heat-map-card.component.scss']
})
export class IRHeatMapCardComponent implements OnInit , OnDestroy{
  static key = 100806;
  
  @ViewChild("IrHeatmapDiv", { static: true }) IrHeatmapDiv!: ElementRef;
  @ViewChild('PivotGrid', { static: false }) pivotGrid!: PivotGridComponent;
  @Input("data") data: any;
  @Input("pageKey") pageKey: any;
  @Input("item") item: any;
  @ViewChild("fs") fs!: ElementRef;
  @HostBinding("class.is-fullscreen") isFullscreen = false;
  isActive: boolean = false;
  isLoading: boolean = true;
  waitingForScatterPlot: boolean = false;
  noData: boolean = false;
  isDataLoaded: boolean = false;
  reqSubcription: Subscription[] = [];
  columnDefs: any = [];
  gridData: any = [];
  gridConfig: any = {}
  pivot: boolean = false;
  config: any={ };
  selectedValue='percent';
  dateFormat: boolean = false;
  headerName:string ='';
  import_from_scatter_plot: boolean = false;
  error_name:any;
  prefrenceConfig:any;
  dashboardKey:any;
  commentsData:any = [];
  props:any={
    xAxisShow :true,
    xAxisFontSize:10,
    xAxisBold:false,
    xAxisColor:'#8A98AB',
    position:"bottom",
    yAxisShow :true,
    yAxisFontSize:12,
    yAxisBold:false,
    yAxisColor:'#101D42',
  }
  kpitimecycle = [
    {
      "value": "D",
      "format": "DD MMM YYYY",
      "label": "Daily"
    },
    {
      "value": "W",
      "format": "DD MMM YYYY",
      "label": "Weekly"
    },
    {
      "value": "M",
      "format": "MMM YYYY",
      "label": "Monthly"
    },
    {
      "value": "Q",
      "format": "MMM YYYY",
      "label": "Quarterly"
    }
    ,
    {
      "value": "Y",
      "format": "YYYY",
      "label": "Yearly"
    }
  ]
  @HostListener('fullscreenchange', ['$event'])
  @HostListener('webkitfullscreenchange', ['$event'])
  @HostListener('mozfullscreenchange', ['$event'])
  @HostListener('MSFullscreenChange', ['$event'])
  screenChange(event: any) {
    if (!document.fullscreenElement) {
      this.isFullscreen = false;
      this.isActive = false;
    }
  }
  

  @Output("onSizeChange") onSizeChange = new EventEmitter<any>();
  constructor(
    private filterService: FilterService,
    private httpClient: HttpClient,
    private apiService: ApiService, 
    private currency:CurrencyPipe,
    private newFilterService :NewFilterService,
    private route: ActivatedRoute,
    private navigationService: NavigationService,
    private userActivityService: UserActivityService,
    private dataService: DataService) 
    {
      this.route.queryParams.subscribe((params: any) => {
      let decryptedParams = this.navigationService.decryptData(params);
      this.dashboardKey = decryptedParams["ds_key"];
    
    });
  }

  changeDisplays($event:any) {
    if (!this.import_from_scatter_plot){
      this.changeDisplayType($event)
    }
  }

  ngOnInit(): void {
    const cfg = this.item.config;
    this.import_from_scatter_plot = cfg?.['import_from_scatter_plot']?.value=='true' || false
    this.getPreferences()

    // observer for resizing of the card
    const observer = new ResizeObserver((e: any) => {
      setTimeout(() => {
        this.onSizeChange.emit(e[0].contentRect.height);
      }, 0);
    });
    observer.observe(this.IrHeatmapDiv.nativeElement);
    this.headerName=cfg['report_heading']


    let storedFilterData: any = null;

    // skip if we want interaction with scatter plot
    if (!this.import_from_scatter_plot){
      // this.filterService.changeDisplays.subscribe((res: any) => {
      //   this.changeDisplayType(res)
      // })
      this.reqSubcription.push(
        this.newFilterService.showBy.subscribe((value:any) => {
          this.isLoading = true;
          this.loadApiData(value);
      }));
      this.selectedValue=cfg?.widget_header_config?.find((fnd: any) => fnd.value == "selection_toggle").toggle_btn[0].value
      // console.log(cfg);
      const widgetKey = this.item?.widget_uniq_key || this.item?.key || 'default';
      this.selectedValue = this.filterService.getSelectionToggle(widgetKey) || this.selectedValue;
      this.loadlineConfig();
    }
    else{
      // Check if we already have some stored data from this session
      // storedFilterData = JSON.parse(sessionStorage.getItem("heatMapFilterData") || '[]');
      // if (storedFilterData && storedFilterData.length != 0){
      //   console.log("HERE");
      //   console.log(storedFilterData);
      //   this.isLoading=true;
      //   this.waitingForScatterPlot = false;
      //   // this.loadApiData(storedFilterData);
      // }
      // else{
      //   this.isLoading=false;
      //   this.waitingForScatterPlot = true;
      // }

      this.isLoading=false;
      // setups subscription to get scatter plot data for heatmap api requests
      this.reqSubcription.push(
        this.newFilterService.scatterPlotData.subscribe((value:any) => {
          // Set the session storage for sources we received for later
          // sessionStorage.setItem("heatMapFilterData", JSON.stringify(value));
          this.isLoading=true;
          this.waitingForScatterPlot = false;
          this.loadApiData(value);
      }));
    }
    // moved subscriptions here
    this.reqSubcription.push(
      this.filterService.filterQuery.subscribe((query: any) => {
        this.isLoading=true
        // want heatmap to go back to the way it looked on load if the user changes the filter
        // only if we are used with the scatter plot and we do not already have data
        if(this.import_from_scatter_plot){
          if(storedFilterData){
            this.loadApiData(storedFilterData)
          }
          else{
            this.loadApiData()
          }
        }
        else{
          this.loadApiData(this.filterService.showByKey);
        }
      })
    );
    
    // Nested Widget subscriptions here
    this.reqSubcription.push(
      this.filterService.triggerNestedQuery.subscribe((query: any) => {
        if(query == this.item.widget_uniq_key) {
          this.isLoading=true
          // want heatmap to go back to the way it looked on load if the user changes the filter
          // only if we are used with the scatter plot and we do not already have data
          if(this.import_from_scatter_plot){
            if(storedFilterData){
              this.loadApiData(storedFilterData)
            }
            else{
              this.loadApiData()
            }
          }
          else{
            this.loadApiData(this.filterService.showByKey);
          }
        }
      })
    );
  }

  loadlineConfig() {
    const cfg = this.item?.['config'] 

    this.config['value'] = {
      XaxisVar: cfg['x_axis']['api_resp_column_nm'] ||  'period',
      YaxisVar: cfg['y_axis']['api_resp_column_nm'] ||  'source_name',
      valueVar: cfg['value_column']['api_resp_column_nm'] || "qty_difference"
    }
    
    this.config['percent'] = {
      XaxisVar: cfg['x_axis']['api_resp_column_nm'] || 'period',
      YaxisVar: cfg['y_axis']['api_resp_column_nm'] || 'source_name',
      valueVar: cfg['percentage_column']['api_resp_column_nm'] || "pct_difference"
    }
  }

  loadApiData(value?: any) {
    let api = this.item.config["list_of_api"] || 'no heatmap apikey found';
      const endpoint = this.item.config?.["list_of_api_endpoint"] || '';

    const cfg = this.item?.['config'];
    if(!this.import_from_scatter_plot){
      if (this.filterService.isEmptyObject(this.filterService.baseQuery) == false) {
        let obj: any = { "api_key":api?.api_key ?? 100134 }// api.api_key }
  
        let query = Object.assign({}, this.filterService.baseQuery, obj)
        query["report_typ"] = value?value:this.filterService.report_type;
        console.log('IR-Heatmap',query["report_typ"]);
        query['module_key'] = this.apiService.getModuleKey();
        query['time_cycle'] = this.filterService?.time_cycle || 'W';
        let endPoint = this.item.config?.["list_of_api_endpoint"]
        this.reqSubcription.push(
          this.httpClient.post(`${this.apiService.apiBaseUrl}/${endpoint||this.apiService.executionUrl}`, query).subscribe((res: any) => {
            const data = (res == null || res == undefined) ? [] : res;
            
            this.mergeCommentsIntoData(data);
          }, (err: any) => {
            this.isLoading=false
            this.data = [];
            this.noData=true
            this.error_name = err?.error?.error?.message || err?.error?.message || err?.message || '';
            console.log(err)
          })
        )
      }
    
    
      // this.reqSubcription.push(this.filterService.executeQuery(obj).subscribe((res: any) => {
      //   this.isDataLoaded = true;
      //   this.data = (res == null || res == undefined ) ? [] : res;
      // }, (error: any) => {
        //   this.data = [];
        //   console.log(error)
        // }));
    }
    // we want to show data based off of data from the scatter plot!
    else{
      let heatMapData:any = [];
      console.log("Data from Scatter Plot in my Heatmap card: ", value);     

      // The user has selected some points
      if(value && value.length != 0){
        // load all past periods using only the sources specified in Scatter Plot selection
        let obj1:any = { "api_key":api?.api_key ?? 999999 }
        let query1 = Object.assign({}, this.filterService.baseQuery, obj1);
  
        query1["from_date"] = this.goBackCycles(query1["to_date"], this.filterService.report_type);
        query1["source_key"] = null;
        //  query based on selected sources and KPIs
        // let givenSources = [...new Set(value.map((item: any) => item.source_name))];
        // query1["source_nm"] = givenSources.join(",");
  
        // let givenKPIName = [...new Set(value.map((item: any) => item.kpi_name))];
        
        // let givenKPIKeys = [...new Set(value.map((item: any) => item.kpi_key))];
        // query1["kpi_key"] = givenKPIKeys.join(",");


        
        // Query now based on x axis key and y axis value
        const uniqueXAxisValues = [...new Set(value.map((item: any) => item.x_axis_key))];
        query1["x_axis_value"] = uniqueXAxisValues.join(",");
        
        // Query now based on x axis key and y axis value
        const uniqueYAxisValues = [...new Set(value.map((item: any) => item.y_axis_key))];
        query1["y_axis_value"] = uniqueYAxisValues.join(",");
  

        query1["report_typ"] = 'D';
        query1["time_cycle"] = this.filterService.report_type;
        query1['report_key']=undefined
        this.reqSubcription.push(
          this.httpClient.post(`${this.apiService.apiBaseUrl}/${this.apiService.executionUrl}`, query1).subscribe((res:any)=> {
            res.forEach((entry:any) =>{
              value.forEach((selection:any) => {
                // TODO: get api calls to return only the keys I need
                // Only use data with corresponding source, KPI key, and location
                if(selection.y_axis_key == entry.y_axis_key && entry.sp_location_name == selection.location_name && entry.x_axis_value == selection.x_axis_value){
                  entry["distinct_name"] = `${entry.x_axis_value} / ${selection.y_axis_value} `;
                  // add in lookback period and number of std dev
                  entry["lookback_period"] = selection.lookback_period;
                  entry["no_of_std_deviations"] = selection?.no_of_std_deviations ?? 2;

                  // Make sure kpi_nm is set correctly
                  entry["kpi_nm"] = selection.kpi_name;
                  // If a location is specified then add it to the distinct name 
                  if(entry.sp_location_name){
                    entry["distinct_name"] = entry["distinct_name"] + " - " + entry.sp_location_name;
                  }
                  heatMapData.push(entry)
                }
              });
            });
            const data = heatMapData;
            this.isDataLoaded = true;
            this.waitingForScatterPlot = false;
            this.isLoading=false;
            this.mergeCommentsIntoData(data);
          },(err:any)=>{
            this.isLoading=false;
            this.data = [];
            this.noData=true;
          })
        )
      }
      // Show the message that the user has to select data in the scatter plot to see heatmap
      else{
        // this.noData = true;
        this.isLoading=false;
        this.waitingForScatterPlot = true;
        // new flag for showing text to select points in the scatter plot
      }
    }

    // //  comment Api Config
    // let reportType = 'S';
    // let userState: any = this.userActivityService.getData();
    // let ir_calc_mode =(this.filterService.showByKey==userState['showBy'+ this.item.config.showby_name] )?this.filterService.showByKey : (userState['showBy'+ this.item.config.showby_name] ? userState['showBy'+ this.item.config.showby_name]:this.filterService.defaultReport_type )
    
    // let postdata:any = { report_typ: reportType, comment_typ: "IRSUM", api_key: "100132" ,show_by_type: null, "ir_calc_mode":ir_calc_mode, ndc_key: null };
    // this.reqSubcription.push(this.filterService.commentsQuery(postdata).subscribe((res: any) => {
    //   this.commentsData = res;
    //   this.mergeCommentsIntoData();
    // }, (err:any) => {
    //   console.log( 'IR Summery comment api ',err)
    // }));
  }

  getgridData(value: any) {
    // debugger
    this.gridData = []
    this.gridConfig = value
    const cfg = this.item?.['config'] 
    let dateFormat:any= this.kpitimecycle?.find(val=> val.value==this.filterService.report_type)?.['format']
    this.columnDefs = this.transformArray( value.pivot ?(cfg?.['value_grid_column']):(cfg?.['pct_grid_column']), dateFormat);
    this.pivot = false
    this.gridData = value.data
    this.isDataLoaded = true

  }
  fullscreenChanges(fullscreen:any){
      this.isFullscreen = fullscreen;
      this.isActive = fullscreen;
 }
 changeDisplayType(value:any){
   this.selectedValue=value

 }
  // Given a date, go back a certain amount of time cycles based on amount
  goBackCycles(dateStr: string, cycle: 'W' | 'M' | 'Q' | 'Y'): string {
    const date = new Date(dateStr);
    const dateCycleMap = {'W': 53, 'M': 13, 'Q': 5, 'Y': 4 }
    let amount = dateCycleMap[cycle];
    switch (cycle) {
        case 'W':
            date.setDate(date.getDate() - (amount * 7));
            break;
        case 'M':
            date.setMonth(date.getMonth() - amount);
            break;
        case 'Q':
            date.setMonth(date.getMonth() - (amount * 3));
            break;
        case 'Y':
            date.setFullYear(date.getFullYear() - amount);
            break;
        default:
            throw new Error("Invalid cycle type. Use 'week', 'month', 'quarter', or 'year'.");
    }
    
    return date.toISOString().split('T')[0]; // Return as YYYY-MM-DD
  }

 numbedPipe(value: any) {
  return this.currency.transform(value, "", "", "1.0-2");
  //  return   this.numberpipe.transform(value)
}
exportXls(){
  this.pivotGrid.exportXls(this.headerName)
}
transformArray(inputArray:any, dateFormat:any) {
  if(inputArray.length==0) return []
  return inputArray.map((item:any) => {
      const newItem:any = {
          headerName: item.header,
          field: item.key,
          cellStyle: { "text-align": "center" }
      };

      if (item.type === 'date') {
          newItem.sort = 'desc';
          newItem.valueFormatter = (params:any) => moment(params.value).format(dateFormat);
      } else if (item.type === 'string') {
          newItem.sort = 'asc';
      } else if (item.type === 'number') {
          newItem.valueFormatter = (params:any) => this.numbedPipe(params.value);
      }

      return newItem;
  });
}
ngOnDestroy(): void {
  this.reqSubcription.forEach(res=> res.unsubscribe())
}
  mergeCommentsIntoData(data:any) {
    
    if (!data) return;

    //  comment Api Config
    let reportType = 'S';
    const dateFormat = this.filterService.time_cycle;
    // let userState: any = this.userActivityService.getData();
    // let ir_calc_mode =(this.filterService.showByKey==userState['showBy'+ this.item.config.showby_name] )?this.filterService.showByKey : (userState['showBy'+ this.item.config.showby_name] ? userState['showBy'+ this.item.config.showby_name]:this.filterService.defaultReport_type )
    
    let postdata:any = { report_typ: reportType, comment_typ: "IRSUM", api_key: "100132" ,show_by_type: null, "ir_calc_mode":this.filterService.showByKey, ndc_key: null };
    this.reqSubcription.push(this.filterService.commentsQuery(postdata).subscribe((res: any) => {
      this.commentsData = res;
      data.forEach((d: any) => {
        const sourceKey = d.source_key || d.data_source_key;
        const count = this.commentsData.filter((c: any) =>
          c.data_source_key == sourceKey &&
          moment(c.period).format("yyyy-MM-DD") == moment(d.period).format("yyyy-MM-DD") &&
          dateFormat == c.time_cycle &&
          c.ir_calc_mode == this.filterService.showByKey
        ).length;
        d.comment_count = count;
        d.comment_flg = count > 0 ? 'Y' : 'N';
      });
      
      this.data = [...data];
      // Refresh the Data
      this.isDataLoaded = true;
      this.isLoading=false
      if(this.data.length==0){this.noData=true}else {this.noData=false}
      this.error_name = '';
    }, (err:any) => {
      // Refresh the Data
       this.data = [...data];
      this.isDataLoaded = true;
      this.isLoading=false
      if(data.length==0){this.noData=true}else {this.noData=false}
      this.error_name = '';
      
      // console.log( 'IR Summery comment api ',err)
    }));
  }

  applyChartPreferences(event: any) {
   
    const updated = { ...this.props };
    if (event) {
      // X-Axis
      updated.xAxisShow = event.xAxis.show;
      updated.xAxisFontSize = event.xAxis.fontSize;
      updated.xAxisBold = event.xAxis.bold;
      updated.xAxisColor = event.xAxis.color;
      updated.position  = event.xAxis.position;
      updated.yAxisShow = event.yAxis.show;
      updated.yAxisFontSize = event.yAxis.fontSize;
      updated.yAxisBold = event.yAxis.bold;
      updated.yAxisColor = event.yAxis.color;

    }
 this.props = { ...updated };
  }
     getPreferences() {
    if(this.item?.widget_uniq_key) {
      let obj = {
        dashboard_key: this.dashboardKey,
        page_name:this.item.config["report_heading"],
        page_key: this.pageKey,
        widget_uinique_key: this.item?.widget_uniq_key,
        employee_key: this.filterService.baseQuery?.employee_key || 0
      }
      this.dataService.getPreference(obj).subscribe((res:any) => {
        if(res && res.length) {
          let value = res?.[0]?.preference_value ? JSON.parse(res?.[0]?.preference_value) : '';
          this.applyChartPreferences(value)
        }
      })
    }
  }
}
